export interface Draft {
  id?: number;
  agencyId: number;
  chapterId: number;
  titleId: number;
  workflowId: number;
  filingActionId?: number;
  draftName: string;
  createdBy?: string;
  createdOn?: Date;
  modifiedBy?: string;
  modifiedOn?: Date;
  isPromulgated: boolean;
}

export const GenerateBlankDraft = () => {
  const blankDraft: Draft = {
    id: -1,
    agencyId: -1,
    chapterId: -1,
    titleId: -1,
    workflowId: -1,
    draftName: '',
    createdBy: '',
    createdOn: new Date(),
    modifiedBy: '',
    modifiedOn: new Date(),
    isPromulgated: false,
  }
  return blankDraft;
}